import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { unsubscribe, UnSubscribeType } from 'wisestep-api';
import { WsButton, WsColors, WsTypography, WsTypoVariants } from 'wisestep-base';

const VendorUnsubscribed = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  useEffect(() => {
    const unSubscribe = async () => {
      const req: UnSubscribeType = {
        globally: false,
        scope: params.get('scope') ?? '',
        who: params.get('who') ?? '',
      };
      await unsubscribe(req);
    };

    unSubscribe();
  }, [params]);
  return (
    <Box m={2}>
      <Box textAlign="center" p={4} bgcolor={WsColors.White} mt={2} borderRadius={2}>
        <WsTypography variant={WsTypoVariants.TITLE} bold>
          You are now Unsubscribed!
        </WsTypography>
        <Box py={3}>
          <WsTypography variant={WsTypoVariants.SUB_TITLE}>
            You will no longer receive emails from Avance Consulting via WiseStep recruitment
            platform.
          </WsTypography>
        </Box>
        <WsButton
          variant="contained"
          onClick={() => navigate(`/subscription?code=${params.get('id')}`)}
        >
          Re-subscribe
        </WsButton>
      </Box>
    </Box>
  );
};
export default VendorUnsubscribed;
